module.exports = __webpack_public_path__ + "static/img/00287v.0820774.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Images/00287v.jpg
// module id = psLX
// module chunks = 1